import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { LogoutResponse } from '../models/logout-response';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private api: ApiService, private authService: AuthService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
        const logoutUrl = this.authService.getLogoutUrl();
        if (logoutUrl) {

          this.authService.setLogoutUrl(null);
          window.location.href = logoutUrl;
          return;
        }

        const currentUrl = window.location.href;
        // TODO: redirect url should be validated/filtered against whitelist or against client logout url
        const redirect_url = params['redirect_url'] ?? currentUrl.slice(0, currentUrl.lastIndexOf("/logout"));

        if (!this.authService.isAuthenticated()) {

          window.location.href = redirect_url;
          return;
        }
        this.authService.setLogoutUrl(redirect_url);
        this.api.logout(currentUrl.split('?')[0]).subscribe((data: LogoutResponse) => {

          this.authService.logout();
          window.location.href = data.redirect_url;
        });
    });
  }
}
